<template>
  <div class="result" :style="resultStyle" v-loading="loading">
      <img class="bg" :src="bg" alt="" :style="bgStyle">
      <div class="content" :style="contentStyle">
          <div class="answer-content">{{comment.content}}</div>
            <div class="code"></div>
            <div class="seal"></div>
            <div class="result-bottom">
                <div class="repetition" @click.stop="repetitionFun"></div>
                <div class="tell" @click.stop="tellFun"></div>
                <div class="college" @click.stop="collegeFun"></div>
            </div>
          <div class="tips-title"></div>
      </div>
      <!-- <div class="answer-title">{{comment.title}}</div> -->
      
      <!-- <div class="flaunt" @click="flauntFun">去晒出我考上的学校~</div> -->
      <img class="canvas-img" :src="canvasSrc" :style="bgStyle" alt="">
      
      <div style="display:none;">
        <!-- <div> -->
        <canvas class="my-canvas" id="canvas" width="750" height="1624" ref="canvas"></canvas>
      </div>
      <div class="popup" v-if="popup" @click.stop="popup=false">
          <div class="popup-content" :style="popupImg?popupimg1:popupimg2"></div>
      </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            resultStyle:'overflow: hidden;',
            bgStyle:'left: 0;top: 0;margin:auto;right:0;bottom:0;',
            contentStyle:'bottom: 36%;',
            score:0,
            comment:{
                title:'',
                content:''
            },
            username:window.localStorage.getItem('kkusername'),
            canvasSrc:'',
            bg:'',
            popup:false,
            canvasbg:'',
            popupImg:true,
            loading:true,
            popupimg1:'background: url('+require('../assets/popup-b.png')+') no-repeat center;background-size: cover;top: 0.2rem;width: 4.22rem;height: 3.47rem;',
            popupimg2:'background: url('+require('../assets/popup-a.png')+') no-repeat center;background-size: cover;bottom: 0.2rem;width: 3.98rem;height: 3.59rem;'
        }
    },
    created(){
        this.loading = true
        if(document.body.clientHeight<667){
            this.resultStyle = 'overflow: auto;'
            this.bgStyle = 'left: 0;top: 0;margin:0;'
            this.contentStyle = 'top: 10rem;bottom:0;'
        }
        this.share()
        this.score = this.$route.query.score
        if(this.score==0){
            this.comment.title = '地核学渣'
            this.comment.content = window.localStorage.getItem('kkusername') + '不瞒你说，你的答题错误率稳居宇宙第一！不过千万不要气馁，这俗话说的好，胜败乃兵家常事，大侠请重新来过～'
            this.bg = require('../assets/canvas-bg4.png')
            this.canvasbg = require('../assets/canvas-bg9.png')
            
        }else if(this.score==20 || this.score==40){
            this.comment.title = '不及格专家'
            this.comment.content = window.localStorage.getItem('kkusername') + '，当年学到的知识，看来你都还给老师啦！告诉我这不是真的，我知道你明明可以答对，为什么要假装自己不知道呢？'
            this.bg = require('../assets/canvas-bg5.png')
            this.canvasbg = require('../assets/canvas-bg10.png')
            
        }else if(this.score==60){
            this.comment.title = '模范学童'
            this.comment.content = window.localStorage.getItem('kkusername') + '你一定是买五年模拟三年高考全套的达人，不管多辛苦多忙碌，坚持爱学习的人设从未倒下过，五湖四海公认的“模范学童”！'
            this.bg = require('../assets/canvas-bg3.png')
            this.canvasbg = require('../assets/canvas-bg8.png')
        }else if(this.score==80 || this.score==100){
            this.comment.title = '佛系学神'
            this.comment.content = '看不出来'+window.localStorage.getItem('kkusername') + '你是抢分达人呀，高考是你的人生高光时刻，超强的学习能力今天依然强悍，妥妥的985、211高材生！'
            this.bg = require('../assets/canvas-bg2.png')
            this.canvasbg = require('../assets/canvas-bg7.png')
        }else if(this.score==120){
            this.comment.title = '宇宙学霸'
            this.comment.content = window.localStorage.getItem('kkusername') + '你就是那个永远被其他家长挂嘴边的“别人家的孩子”，清华北大和蓝翔技校，只有你不想去的学校，没有你考不上的专业~'
            this.bg = require('../assets/canvas-bg1.png')
            this.canvasbg = require('../assets/canvas-bg6.png')
        }
        
    },
    mounted(){
        this.canvasGenerate()
    },
    methods:{
        tellFun(){
            window._czc.push(['_trackEvent', '夸克', '点击', '告诉朋友','1','1']);
            this.popup=true
            let ualist = navigator.userAgent
            if(ualist.indexOf('Quark')==-1){
                this.popupImg = true
            }else{
                this.popupImg = false
            }
        },
        share(){
                    // 微信分享
            window.wx.ready(() => {
                // 分享好友
                window.wx.updateAppMessageShareData({
                title: "测测你的高考剩余值", // 分享标题
                desc: "如果重返高考考场，你到底还能拿多少分呢？", // 分享描述
                link: "https://h5case3.xiaoxxx.cn/202105/quark-answer2/index.html", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl:
                    "https://h5case3.xiaoxxx.cn/202105/quark-answer/src/assets/fx.jpg", // 分享图标
                success: function () {
                    // 设置成功
                    // window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享好友次数', '分享好友次数','1','1']);
                },
                });
                // 分享朋友圈
                window.wx.updateTimelineShareData({
                title: "测测你的高考剩余值", // 分享标题
                link: "https://h5case3.xiaoxxx.cn/202105/quark-answer2/index.html", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl:
                    "https://h5case3.xiaoxxx.cn/202105/quark-answer/src/assets/fx.jpg", // 分享图标
                success: function () {
                    // 设置成功
                    // window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享朋友圈次数', '分享朋友圈次数','1','1']);
                },
                });
            });
        },
        repetitionFun(){
            window._czc.push(['_trackEvent', '夸克', '点击', '我要重考','1','1']);
            this.$router.push({path:'/home'})
        },
        collegeFun(){
            window._czc.push(['_trackEvent', '夸克', '点击', '志愿填报','1','1']);
            window.location.href = 'https://broccoli.uc.cn/apps/vc80_LDeL/routes/9Kw6beSld?uc_param_str=dsdnutlbgpmiosntnnfrpfbivepcsvpr&uc_biz_str=S%3Acustom%7CC%3Afull_screen%7COPT%3ABACK_BTN_STYLE%400%7Cqk_enable_gesture%3Afalse%7COPT%3ATOOLBAR_STYLE%400%7COPT%3AS_BAR_BG_COLOR%40ffffff%7COPT%3AW_PAGE_REFRESH%400&entry=navi'
        },
        flauntFun(){
            // let obj={
            //     title:this.answerTitle,
            //     content:this.answerContent
            // }
            // // console.log(obj)
            // this.$router.push({path:'/canvasGenerate',query:{data:obj}})
        },
        canvasGenerate(){
            this.loading = true
            let canvas = this.$refs.canvas;
            let ctx = canvas.getContext("2d");
            ctx.fillStyle = "#fff";
            ctx.fillRect(0, 0, 750, 1624);
            // 画背景图片
            let bottom_img = new Image();
            bottom_img.src = this.canvasbg;
            bottom_img.onload = () => {
              ctx.drawImage(bottom_img, 0, 0, 750, 1624);
            // //   // 画头像图片
              let avater_img = new Image();
              avater_img.src = require('../assets/code.png');
              avater_img.onload = () => {
                  ctx.drawImage(avater_img, 572, 1190, 147, 147);
                     ctx.beginPath();
                        ctx.fillStyle = "#000000";
                        ctx.font = "36px siyuan";
                        ctx.textAlign = "left";
                        this.drawtext(ctx,this.comment.content,30,1170,535)
                        let seal_img = new Image()
                        seal_img.src = require('../assets/seal.png')
                        seal_img.onload = ()=>{
                        ctx.drawImage(seal_img,470,1310,130,130)
                        setTimeout(() => {
                            //canvas转换图片
                            let base64_ = canvas.toDataURL("image/png");
                            this.canvasSrc = base64_
                            this.loading = false
                            // console.log(base64_)
                        }, 1000);
                    }
                };
            };
        },
        // 文字换行
        drawtext(ctx,t,x,y,w){
            //参数说明
            //ctx：canvas的 2d 对象，t：绘制的文字，x,y:文字坐标，w：文字最大宽度
            let chr = t.split("")
            let temp = ""
            let row = []

            for (let a = 0; a<chr.length;a++){
                if( ctx.measureText(temp).width < w && ctx.measureText(temp+(chr[a])).width <= w){
                    temp += chr[a];
                }else{
                    row.push(temp);
                    temp = chr[a];
                }
            }
            row.push(temp)
            for(let b=0;b<row.length;b++){
                ctx.fillText(row[b],x,y+(b+1)*50);//每行字体y坐标间隔20
            }

        }
    }
}
</script>

<style scoped>
.result{
    width: 100%;
    height: 100%;
    position: relative;
    
    font-size: 0.3rem;
    -webkit-touch-callout:none;
    -webkit-user-select:none;
    -khtml-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
}
.popup{
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 21;
    position: fixed;
    left: 0;
    top: 0;
}
.popup-content{
    
    
    position: absolute;
    right: 0.2rem;
}
.bg{
    position: absolute;
    
    width: 100%;
}
/* .answer-title{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: calc(50% - 3rem);
    font-size: 0.36rem;
    font-family: siyuan;
} */
.content{
    position: absolute;
    
    width: 100%;
}
.answer-content{
    position: absolute;
    left: 0.3rem;
    top: 0.2rem;
    font-size: 0.36rem;
    font-family: siyuan;
    text-align: left;
    line-height: 0.5rem;
    width: 5.35rem;
}
.seal{
    width: 1.3rem;
    height: 1.3rem;
    background: url('../assets/seal.png') no-repeat center;
    background-size: cover;
    position: absolute;
    right: 1.6rem;
    top: 1.5rem;
}
.code{
    width: 1.47rem;
    height: 1.47rem;
    background: url('../assets/code.png') no-repeat center;
    background-size: cover;
    position: absolute;
    top: 0.3rem;
    right: 0.3rem;
}
.result-bottom{
    position: absolute;
    left: 0;
    right: 0;
    /* transform: translateX(-50%); */
    top: 2.8rem;
    /* display: flex; */
    z-index: 20;
    /* justify-content: center; */
    width: 100%;
        /* width: fit-content; */
    text-align: center;
    /* margin: 0 auto; */

}
/* .result-bottom:after{
    content:"";
    display:block;
    clear:both;
    height:0;
    overflew:hidden;
} */
.repetition,.college,.tell{
    width: 1.92rem;
    height: 0.78rem;
    /* float: left; */
    display: inline-block;
}
.tell{
    background: url('../assets/tell.png') no-repeat center;
    background-size: cover;
    margin: 0 0.25rem;
}
.repetition{
    background: url('../assets/anew.png') no-repeat center;
    background-size: cover;
}
.college{
    background: url('../assets/volunteer.png') no-repeat center;
    background-size: cover;
}
/* .flaunt{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 1rem;
    color: blue;
} */
.canvas-img{
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    /* right: 0; */
    /* bottom: 0; */
    /* margin: auto; */
    /* transform: translate(-50%,-50%); */
    z-index: 10;
    opacity: 0;
}
.tips-title{
    width: 3.01rem;
    height: 0.67rem;
    position: absolute;
    /* left: 50%; */
    left: 0;
    right: 0;
    margin: 0 auto;
    /* transform: translateX(-50%); */
    top: 3.7rem;
    background: url('../assets/save-bg.png') no-repeat center;
    background-size: cover;
}
</style>